var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 42,
    viewBox: "0 0 35 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39998 8.3999H5.59998V9.7999H8.39998V8.3999Z",
    fill: "#CCAC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39995 9.7998H4.19995V11.1998H8.39995V9.7998Z",
    fill: "#FFD700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39995 11.1997H4.19995V13.9997H8.39995V11.1997Z",
    fill: "#FFD700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39995 14H4.19995V15.4H8.39995V14Z",
    fill: "#CCAC00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39998 15.3999H5.59998V16.7999H8.39998V15.3999Z",
    fill: "#CCAC00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59995 9.7998H4.19995V11.1998H5.59995V9.7998Z",
    fill: "#FFED4E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59995 11.1997H4.19995V13.9997H5.59995V11.1997Z",
    fill: "#FFE44D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4 8.3999H26.6V9.7999H29.4V8.3999Z",
    fill: "#CCAC00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 9.7998H26.6V11.1998H30.8V9.7998Z",
    fill: "#FFD700"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 11.1997H26.6V13.9997H30.8V11.1997Z",
    fill: "#FFD700"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 14H26.6V15.4H30.8V14Z",
    fill: "#CCAC00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4 15.3999H26.6V16.7999H29.4V15.3999Z",
    fill: "#CCAC00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 9.7998H29.4V11.1998H30.8V9.7998Z",
    fill: "#DDB900"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 11.1997H29.4V13.9997H30.8V11.1997Z",
    fill: "#CCAA00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2001 5.6001H9.80005V7.0001H25.2001V5.6001Z",
    fill: "#CCAC00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 7H8.40002V8.4H26.6V7Z",
    fill: "#DDB900"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2001 7H9.80005V8.4H25.2001V7Z",
    fill: "#FFED4E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 8.3999H8.40002V9.7999H26.6V8.3999Z",
    fill: "#FFD700"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 9.7998H8.40002V11.1998H26.6V9.7998Z",
    fill: "#FFD700"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2001 11.1997H9.80005V12.5997H25.2001V11.1997Z",
    fill: "#FFD700"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2001 12.6001H9.80005V14.0001H25.2001V12.6001Z",
    fill: "#FFD700"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8001 14H11.2001V15.4H23.8001V14Z",
    fill: "#FFD700"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8001 15.3999H11.2001V16.7999H23.8001V15.3999Z",
    fill: "#FFD700"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 16.7998H12.6V18.1998H22.4V16.7998Z",
    fill: "#FFD700"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 18.1997H12.6V19.5997H22.4V18.1997Z",
    fill: "#FFD700"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.6001H14V21.0001H21V19.6001Z",
    fill: "#FFD700"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 8.3999H9.80005V9.7999H12.6V8.3999Z",
    fill: "#FFED4E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.7998H9.80005V11.1998H14V9.7998Z",
    fill: "#FFF266"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4001 11.1997H11.2001V12.5997H15.4001V11.1997Z",
    fill: "#FFF68F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8001 12.6001H11.2001V14.0001H16.8001V12.6001Z",
    fill: "#FFFAAB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 14H12.6V15.4H16.8V14Z",
    fill: "#FFFAAB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 15.3999H12.6V16.7999H15.4V15.3999Z",
    fill: "#FFF68F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 8.3999H22.4V9.7999H26.6V8.3999Z",
    fill: "#DDB900"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 9.7998H21V11.1998H25.2V9.7998Z",
    fill: "#CCAA00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 11.1997H21V12.5997H25.2V11.1997Z",
    fill: "#CCAA00"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8 12.6001H19.6V14.0001H23.8V12.6001Z",
    fill: "#CCAA00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8 14H19.6V15.4H23.8V14Z",
    fill: "#BB9900"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 15.3999H19.6V16.7999H22.4V15.3999Z",
    fill: "#BB9900"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 21H12.6V22.4H22.4V21Z",
    fill: "#CCAC00"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21H14V22.4H21V21Z",
    fill: "#DDB900"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 22.3999H15.4V23.7999H19.6V22.3999Z",
    fill: "#CCAC00"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 23.7998H15.4V25.1998H19.6V23.7998Z",
    fill: "#FFD700"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 25.1997H15.4V27.9997H19.6V25.1997Z",
    fill: "#FFD700"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 28H15.4V29.4H19.6V28Z",
    fill: "#CCAC00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 23.7998H15.4V25.1998H16.8V23.7998Z",
    fill: "#FFE44D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 25.1997H15.4V27.9997H16.8V25.1997Z",
    fill: "#FFE44D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6001 23.7998H18.2001V25.1998H19.6001V23.7998Z",
    fill: "#DDB900"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6001 25.1997H18.2001V27.9997H19.6001V25.1997Z",
    fill: "#CCAA00"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29.3999H14V30.7999H21V29.3999Z",
    fill: "#CCAC00"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4001 30.7998H12.6001V32.1998H22.4001V30.7998Z",
    fill: "#DDB900"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30.7998H14V32.1998H21V30.7998Z",
    fill: "#FFED4E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8001 32.1997H11.2001V33.5997H23.8001V32.1997Z",
    fill: "#FFD700"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2001 33.6001H9.80005V35.0001H25.2001V33.6001Z",
    fill: "#FFD700"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2001 35H9.80005V36.4H25.2001V35Z",
    fill: "#CCAC00"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 32.1997H11.2001V33.5997H14.0001V32.1997Z",
    fill: "#FFE44D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M14 33.6001H9.80005V35.0001H14V33.6001Z",
    fill: "#FFE44D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8001 32.1997H19.6001V33.5997H23.8001V32.1997Z",
    fill: "#DDB900"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 33.6001H21V35.0001H25.2V33.6001Z",
    fill: "#CCAA00"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 35H21V36.4H25.2V35Z",
    fill: "#BB9900"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 36.3999H8.40002V37.7999H26.6V36.3999Z",
    fill: "#6A6A6A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2001 36.3999H9.80005V37.7999H25.2001V36.3999Z",
    fill: "#8A8A8A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M28 37.7998H7V39.1998H28V37.7998Z",
    fill: "#5A5A5A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 37.7998H8.40002V39.1998H26.6V37.7998Z",
    fill: "#7A7A7A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M12.6 9.7998H11.2V11.1998H12.6V9.7998Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M14 11.1997H12.6V12.5997H14V11.1997Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.7999 8.3999H15.3999V9.7999H16.7999V8.3999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.df7b31fd51efb648be8ea294dcc21487.svg";
export { ForwardRef as ReactComponent };